<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="600px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="关卡名称：" prop="name" class="width100">
        <el-input v-model="form.name" placeholder="请输入关卡名称" maxlength="10" show-word-limit />
      </el-form-item>
      <el-form-item label="闯关时间：" prop="dateTime" class="width100">
        <el-date-picker v-model="form.dateTime" size="small" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="预警提示：" prop="warningPrompt" class="width100">
        <el-input v-model="form.warningPrompt" placeholder="落后几个阶段预警提示用户">
          <i class="el-input__icon" slot="suffix">阶段</i>
        </el-input>
      </el-form-item>
      <el-form-item label="移除学员：" prop="removeStudent" class="width100">
        <el-input v-model="form.removeStudent" placeholder="落后几个阶段移除学员">

          <i class="el-input__icon" slot="suffix">阶段</i>
        </el-input>
      </el-form-item>
      <el-form-item label="关卡介绍：" prop="introduce" class="width100">
        <el-input v-model="form.introduce" type="textarea" :rows="4" placeholder="请输入关卡介绍" maxlength="200" show-word-limit />
      </el-form-item>
      <el-form-item label="状态：" prop="state" class="width100">
        <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch> {{form.state?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import courseSubjectBarrierApi from '@/api/course/courseSubjectBarrier'
function initFormBean() {
  const formBean = {
    id: null,
    name: null,
    dateTime: null,
    warningPrompt: null,
    removeStudent: null,
    introduce: null,
    state: 0,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      old: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入关卡名称', trigger: 'blur' }],
        dateTime: [{ required: true, message: '请选择闯关时间', trigger: 'change' }],
        introduce: [{ required: true, message: '请输入关卡介绍', trigger: 'blur' }],
        warningPrompt: [{ required: true, message: '落后几个阶段预警提示用户', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        removeStudent: [{ required: true, message: '落后几个阶段移除学员', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      for (const key in initFormBean()) {
        this.form[key] = this.old[key]
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.form = initFormBean()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.old = { ...row }
      this.resetForm()
      if (row.startTime && row.endTime) this.$set(this.form, 'dateTime', [row.startTime, row.endTime])
      else this.$set(this.form, 'dateTime', [])
      this.formVisible = true
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.startTime = params.dateTime && params.dateTime.length > 0 ? params.dateTime[0] : null
      params.endTime = params.dateTime && params.dateTime.length > 0 ? params.dateTime[1] : null
      params.warningPrompt = +params.warningPrompt || 0
      params.removeStudent = +params.removeStudent || 0
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          delete params.dateTime
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseSubjectBarrierApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseSubjectBarrierApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 47%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.full-box {
  display: flex;
  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;
    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
.item-box {
  margin-bottom: 10px;
  .el-icon-delete {
    font-size: 18px;
    color: #d81e06;
    cursor: pointer;
  }
}
.el-table {
  margin-bottom: 10px;
}
::v-deep .el-date-editor {
  width: 100%;
}
</style>
